import { Button, ButtonProps } from "@mui/material"
import { useLayoutContext } from "layout/oldLayout/LayoutContext"
import { Link, LinkProps } from "react-router-dom"
import styled from "styled-components"
import { Font } from "../wizard/constants"

const StyledListItem = styled.li`
  list-style-type: none;
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid ${(p) => p?.theme?.colors?.lightGrey};
  height: 60px;

  :first-child {
    border-top: none;
  }
`

type StyledButtonLinkProps = React.FC<ButtonProps & LinkProps>

const StyledButtonLink = styled<StyledButtonLinkProps>(Button).attrs({
  component: Link,
})`
  text-decoration: underline;
  text-underline-offset: 5px;
  padding: 0;
  min-width: 0;
`

const StyledCirclePicture = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
`

const StyledContainer = styled.div`
  display: flex;
  align-items: center;
`

const StyledText = styled.span`
  font-family: ${Font.OENaPro};
  font-size: 16px;
  font-weight: 300;
  line-height: 22px;
  letter-spacing: 0em;
  padding-right: 13px;
`

type SelectionProps = {
  imageUrl?: string
  detailTitle: string
  editUrl: string
}

const EditDetailingSelection = ({
  imageUrl,
  detailTitle,
  editUrl,
}: SelectionProps) => {
  const { focusMain } = useLayoutContext()

  const itemKey = Math.random() + detailTitle

  return (
    <StyledListItem key={itemKey}>
      <StyledContainer>
        {imageUrl && <StyledCirclePicture src={imageUrl} />}
        <StyledText>{detailTitle}</StyledText>
      </StyledContainer>
      <StyledButtonLink
        onClick={() => {
          focusMain()
        }}
        to={editUrl}
      >
        שינוי
      </StyledButtonLink>
    </StyledListItem>
  )
}

export default EditDetailingSelection
